<ion-content class="image-modal">
  <img [src]="imageUrl" alt="Event Image" (error)="$event.target.src='assets/img/event-placeholder.svg'">
  <ion-button expand="full" color="light" (click)="close()">Close</ion-button>
</ion-content>
